export type GridSelectionMode = 'single' | 'multiple' | 'none';

export interface GridConfig {
  // ── Paginação ──────────────────────────────────────────────────────────────
  readonly pageSize: number;
  /** true = nz-table gerencia paginação/sort/filtro internamente (modo cliente).
   *  false (padrão) = paginação externa / server-side. */
  readonly frontPagination: boolean;
  readonly showPagination: boolean;
  readonly paginationType: 'default' | 'small';
  readonly paginationPosition: 'top' | 'bottom' | 'both';
  readonly simplePagination: boolean;

  // ── Seleção ────────────────────────────────────────────────────────────────
  readonly selectionMode: GridSelectionMode;
  readonly persistentSelection: boolean;

  // ── Visual ────────────────────────────────────────────────────────────────
  readonly bordered: boolean;
  readonly size: 'default' | 'middle' | 'small';
  readonly title: string | null;
  readonly footer: string | null;
  /** Ativa a coluna expansível e o slot de conteúdo da linha. */
  readonly expandable: boolean;
  /** Trunca texto longo nas células (requer tableLayout=fixed). */
  readonly ellipsis: boolean;
  /** Altura da área de scroll vertical para cabeçalho fixo, ex.: '320px'. null = sem fixo. */
  readonly scrollY: string | null;

  // ── Legacy / compatibilidade ───────────────────────────────────────────────
  readonly autoHeight: boolean;
}

export const DEFAULT_GRID_CONFIG: GridConfig = {
  pageSize: 10,
  frontPagination: false,
  showPagination: true,
  paginationType: 'small',
  paginationPosition: 'bottom',
  simplePagination: false,
  selectionMode: 'multiple',
  persistentSelection: false,
  bordered: false,
  size: 'middle',
  title: null,
  footer: null,
  expandable: false,
  ellipsis: false,
  scrollY: null,
  autoHeight: false,
};
